/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_Attach_DescInputs */

const vi_camera_station_attach_desc = /** @type {(inputs: Camera_Station_Attach_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera được thêm vào trạm này, vẫn giữ các nơi đang gắn.`)
};

/**

* @param {Camera_Station_Attach_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_attach_desc = /** @type {((inputs?: Camera_Station_Attach_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_Attach_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_attach_desc(inputs)
});